import React, { useState } from 'react';

function ConversationList({ conversations, currentConversation, onSelect, onDelete, onUpdateTitle }) {
  const [editingId, setEditingId] = useState(null);
  const [editTitle, setEditTitle] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const startEdit = (conv) => {
    setEditingId(conv.id);
    setEditTitle(conv.title);
  };

  const saveEdit = (id) => {
    onUpdateTitle(id, editTitle);
    setEditingId(null);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const filteredConversations = conversations.filter(conv => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    const title = (conv.title || `Conversation ${conv.id}`).toLowerCase();
    const lastMessage = conv.last_message?.content?.toLowerCase() || '';
    return title.includes(query) || lastMessage.includes(query);
  });

  return (
    <div className="conversation-list">
      <h3>Conversations</h3>
      {conversations.length > 0 && (
        <div className="search-box">
          <input
            type="text"
            placeholder="Search conversations..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="conversation-search"
          />
          {searchQuery && (
            <button 
              className="clear-search"
              onClick={() => setSearchQuery('')}
              title="Clear search"
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
      )}
      {conversations.length === 0 ? (
        <p className="empty-state">No conversations yet. Create one to get started!</p>
      ) : filteredConversations.length === 0 ? (
        <p className="empty-state">No conversations match your search.</p>
      ) : (
        <div className="conversations">
          {filteredConversations.map(conv => (
            <div
              key={conv.id}
              className={`conversation-item ${currentConversation?.id === conv.id ? 'active' : ''}`}
            >
              {editingId === conv.id ? (
                <div className="edit-mode">
                  <input
                    type="text"
                    value={editTitle}
                    onChange={(e) => setEditTitle(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && saveEdit(conv.id)}
                    autoFocus
                  />
                  <button onClick={() => saveEdit(conv.id)}>Save</button>
                  <button onClick={() => setEditingId(null)}>Cancel</button>
                </div>
              ) : (
                <>
                  <div className="conv-main" onClick={() => onSelect(conv.id)}>
                    <div className="conv-title">{conv.title || `Conversation ${conv.id}`}</div>
                    <div className="conv-meta">
                      <span className="msg-count">{conv.message_count || 0} messages</span>
                      <span className="conv-date">{formatDate(conv.updated_at)}</span>
                    </div>
                    {conv.last_message && (
                      <div className="last-message">
                        {conv.last_message.content.substring(0, 60)}...
                      </div>
                    )}
                  </div>
                  <div className="conv-actions">
                    <button
                      className="btn-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        startEdit(conv);
                      }}
                      title="Edit title"
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      className="btn-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm('Delete this conversation?')) {
                          onDelete(conv.id);
                        }
                      }}
                      title="Delete"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ConversationList;
